import React from "react";
import { Paragraph, useTheme } from "@tvg/design-system";
import { RacePool } from "@tvg/ts-types/Race";
import { formatCurrencyShortened } from "@tvg/formatter/currency";
import { THead, Th, Tr } from "../styled-components";
import { MAX_AMOUNT } from "../constants";
import { getOrderedRacePools } from "../handlers";
import TooltipExceededAmounts from "./TooltipExceededAmounts";

interface Props {
  racePools: RacePool[];
  wagerTypeLimit: number;
}

const WagerTypePools = ({ racePools, wagerTypeLimit }: Props) => {
  const { colors } = useTheme();

  const orderedRacePools = getOrderedRacePools(
    racePools,
    wagerTypeLimit,
    false
  );

  if (orderedRacePools.length === 0) {
    return null;
  }

  return (
    <THead data-qa-label="pools-table-header">
      <Tr backgroundColor={colors.blue_accent["000"]}>
        <Th first textCenter>
          <Paragraph
            fontSize="s"
            fontWeight={600}
            color="grey.900"
            qaLabel="pools-wagerType-name"
          >
            #
          </Paragraph>
        </Th>

        {orderedRacePools.map((pool: RacePool) => (
          <Th
            key={`pools-column-${pool.wagerType.code}`}
            data-qa-label={`pools-column-${pool.wagerType.code}`}
          >
            <Paragraph
              fontSize="s"
              fontWeight={600}
              color="grey.900"
              qaLabel="pools-wagerType-name"
            >
              {pool.wagerType.name}
            </Paragraph>
            <br />
            <Paragraph
              fontSize="xs"
              fontWeight={400}
              color="grey.800"
              qaLabel="pools-amount"
            >
              {pool.amount > MAX_AMOUNT ? (
                <TooltipExceededAmounts amount={pool.amount} />
              ) : (
                formatCurrencyShortened(pool.amount, "USD", 0)
              )}
            </Paragraph>
          </Th>
        ))}
      </Tr>
    </THead>
  );
};

export default WagerTypePools;
